export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7275.48b26b3e.jpg";